import React from 'react';
import { Button } from '@design-system/Button';
import { InfoSheet } from '@screens/HealthPages/InfoSheet';
import { INFO_SHEET_CONTENT } from '@/utils/InfoSheet/InfoSheetContent';

interface SymptomsSectionProps {
  symptoms: string[];
  'data-testid'?: string;
}

export const SymptomsSection: React.FC<SymptomsSectionProps> = ({
  symptoms,
  'data-testid': testId,
}) => (
  <div className="mt-6" data-testid={testId}>
    <div className="flex items-center" data-testid="healthL2Details-symptomsHeader">
      <h2 className="typography-h3 mr-2" data-testid="healthL2Details-symptomsTitle">Commonly Linked Symptoms</h2>
      <InfoSheet
        title={INFO_SHEET_CONTENT.linkedSymptoms.title}
        description={INFO_SHEET_CONTENT.linkedSymptoms.description}
        data-testid="healthL2Details-symptomsInfoSheet"
      />
    </div>

    <div className="flex flex-wrap max-w-[35rem] mt-6 gap-x-2 gap-y-4" data-testid="healthL2Details-symptomsList">
      {symptoms?.map((symptom, index) => (
        <Button
          key={`${symptom}-${index}`}
          variant="outline"
          size="sm"
          className="dark cursor-default bg-transparent rounded-[0.5rem]"
          disabled={true}
          data-testid={`healthL2Details-symptom-${index}`}
        >
          <p className="text-white" data-testid={`healthL2Details-symptomText-${index}`}>{symptom}</p>
        </Button>
      ))}
    </div>
  </div>
);
